import React, { useEffect, useState } from "react";
import { Session } from "@intech/react-service";
import { BaseAuth } from "../Login/Base";
import { Alert } from "@intech/web-ui";
import { PlanoVinculadoEntidade } from "@entidades";
import { AuthService } from "@services";
import { useHistory } from "react-router-dom";
import { LoadingComponent } from "@components";
import { ContratoDisponivelButton, ContratoDisponivelButtonContainer, ListaContrato } from "./styles";

export const SelecionarContrato: React.FC<any> = () => {
  const history = useHistory();

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");
  const [Contratos, setContratos] = useState<Array<PlanoVinculadoEntidade>>([]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const Contratos = await AuthService.BuscarContratos();
        setContratos(Contratos);
      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  async function selecionar(SQ_CONTRATO_TRABALHO: number) {
    try {
      setLoading(true);
      const login = await AuthService.SelecionarContrato(SQ_CONTRATO_TRABALHO, 1);
      await Session.setToken(login.AccessToken);

      history.push("/");
    } catch (e) {
      const err: any = e;
      setErro(err.response ? err.response.data : err);
    }
    finally {
      setLoading(false);
    }
  }

  return (
    <BaseAuth tamanho={600}>
      {Loading && <LoadingComponent />}
      {!Loading && Erro !== "" && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && Erro === "" && <>
        <h5>
          <b>
            {"Encontramos os seguintes contratos vinculados ao seu CPF. Para continuar no Portal favor selecionar uma opção abaixo:"}
          </b>
        </h5>

        <ListaContrato>
          {Contratos.map((contrato, index) => {
            return (
              <ContratoDisponivelButtonContainer key={index}>
                <ContratoDisponivelButton onClick={() => selecionar(contrato.SQ_CONTRATO_TRABALHO)}>
                  <b>{contrato.DS_PLANO_PREVIDENCIAL}</b>
                  <div>Situação: {contrato.DS_SIT_PLANO}</div>
                  <div>Matrícula: {contrato.NR_REGISTRO}</div>
                </ContratoDisponivelButton>
              </ContratoDisponivelButtonContainer>
            );
          })}
        </ListaContrato>
      </>}
    </BaseAuth>
  );
}